// extracted by mini-css-extract-plugin
export default {"new_project_wrapper":"NewFidaProjectForm_new_project_wrapper__-dviG","field_wrapper":"NewFidaProjectForm_field_wrapper__O4k3N","field_label":"NewFidaProjectForm_field_label__FNaOc"};